import {call, fork, put, select, take} from 'redux-saga/effects';
import _ from 'lodash';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Get list of issues
 * */
function* getIssues(pagination = {}) {
    let response = {};

    try {
        response = yield call(api.getIssues, pagination);
    } catch(error) {
        yield put({
            type: actionTypes.GET_ISSUES.FAILURE,
            errors: response.data,
            error: error,
        });

        return response.data;
    }

    if (response && !response.errors.length) {
        yield put({
            type: actionTypes.GET_ISSUES.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_ISSUES.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchGetIssues() {
    while (true) {
        const { pagination } = yield take(actionTypes.GET_ISSUES.REQUEST);
        yield fork(getIssues, pagination);
    }
}

/**
 * Get issue by id
 * */
export function* getIssue(id) {
    const response = yield call(api.getIssue, id);

    if (response && !response.errors.length) {
        yield put({
            type: actionTypes.GET_ISSUE.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_ISSUE.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchGetIssue() {
    while (true) {
        const { id } = yield take(actionTypes.GET_ISSUE.REQUEST);
        yield fork(getIssue, id);
    }
}

/**
 * Get list of issues
 * */
function* updateIssueStatus(id, status) {
    let response = {};

    try {
        response = yield call(api.updateIssueStatus, id, status);
    } catch(error) {
        yield put({
            type: actionTypes.UPDATE_ISSUE_STATUS.FAILURE,
            errors: response.data,
            error: error,
        });

        return response.data;
    }

    if (response && !response.errors.length) {
        yield put({
            type: actionTypes.UPDATE_ISSUE_STATUS.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.UPDATE_ISSUE_STATUS.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchUpdateIssueStatus() {
    while (true) {
        const { id, status } = yield take(actionTypes.UPDATE_ISSUE_STATUS.REQUEST);
        yield fork(updateIssueStatus, id, status);
    }
}

/**
 * add issue comment
 * */
function* addIssueComment(id, data) {
    let response = {};

    try {
        response = yield call(api.addIssueComment, id, data);
    } catch(error) {
        yield put({
            type: actionTypes.ADD_ISSUE_COMMENT.FAILURE,
            errors: response.data,
            error: error,
        });

        return response.data;
    }

    if (response && !response.errors.length) {
        yield put({
            type: actionTypes.ADD_ISSUE_COMMENT.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.ADD_ISSUE_COMMENT.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchAddIssueComment() {
    while (true) {
        const { id, data } = yield take(actionTypes.ADD_ISSUE_COMMENT.REQUEST);
        yield fork(addIssueComment, id, data);
    }
}

/**
 * update issue comment
 * */
function* updateIssueComment(id, commentId, data) {
    let response = {};

    try {
        response = yield call(api.updateIssueComment, id, commentId, data);
    } catch(error) {
        yield put({
            type: actionTypes.UPDATE_ISSUE_COMMENT.FAILURE,
            errors: response.data,
            error: error,
        });

        return response.data;
    }

    if (response && !response.errors.length) {
        yield put({
            type: actionTypes.UPDATE_ISSUE_COMMENT.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.UPDATE_ISSUE_COMMENT.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchUpdateIssueComment() {
    while (true) {
        const { id, commentId, data } = yield take(actionTypes.UPDATE_ISSUE_COMMENT.REQUEST);
        yield fork(updateIssueComment, id, commentId, data);
    }
}


/**
 * delete issue comment
 * */
function* deleteIssueComment(id, commentId) {
    let response = {};

    try {
        response = yield call(api.deleteIssueComment, id, commentId);
    } catch(error) {
        yield put({
            type: actionTypes.DELETE_ISSUE_COMMENT.FAILURE,
            errors: response.data,
            error: error,
        });

        return response.data;
    }

    if (response && !response.errors.length) {
        yield put({
            type: actionTypes.DELETE_ISSUE_COMMENT.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.DELETE_ISSUE_COMMENT.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchDeleteIssueComment() {
    while (true) {
        const { id, commentId } = yield take(actionTypes.DELETE_ISSUE_COMMENT.REQUEST);
        yield fork(deleteIssueComment, id, commentId);
    }
}

export default [
    watchGetIssues,
    watchGetIssue,
    watchUpdateIssueStatus,
    watchAddIssueComment,
    watchUpdateIssueComment,
    watchDeleteIssueComment,
];




// WEBPACK FOOTER //
// ./app/sagas/issues.js